import { Country } from 'domain/api/graphql/generated';

import { useAccountContext } from '../useAccountContext';

export const useCompanyCountry = () => {
  const { currentCompany } = useAccountContext();

  return currentCompany?.country || Country.All;
};
